import React, {Component} from "react";
import {Link} from "react-router-dom";
import {Container} from "semantic-ui-react"
import TinySlider from "tiny-slider-react";

import {APP} from '../../constants';

import {Banner, Menu} from "./components/";

const settings = {
    lazyload: true,
    nav: true,
    navPosition: 'bottom',
    controls: false,
    loop: true,
    autoplay: true,
    items: 1
};

const Banners = ({banners, city, city_id,}) => {
    const path = APP.images.posts.banner;
    const path_mobile = APP.images.posts.banner_mobile;
    const city_url = `/city/${city_id}/${city.slug}`;
    const parent = {display: "flex", width: "100%", height: "100%", alignItems: "flex-end"};
    let style= {
        backgroundColor: 'rgba(0, 0, 0, .66)',
        color: '#FFF',
        textAlign: "center",
        width: "100%",
        fontWeight: "300"
    }

    if(banners.length > 1){
        style.paddingTop = 8;
        style.marginBottom = 48;
    }else{
        style.padding = 12;
    }

    return (
        <TinySlider settings={settings}>
            {
                banners.map((o)=> {
                    let banner = `url(${path}${o.banner})`;
                    if(window['isMobile'] && o.banner_mobile){
                        banner = `url(${path_mobile}${o.banner_mobile})`;
                    }
                    return (
                        <Link to={`${city_url}/read/${o.id}/${o.slug}?category=${o.category_id}`} key={`banner-${o.id}`}>
                            <div className={"xbanner"} style={{backgroundImage: banner}}>
                                <div style={parent}>
                                    <div style={style}>
                                        <h2>{o.title}</h2>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    )
                })
            }
        </TinySlider>
    );
}

export class Header extends Component {
    render() {
        const {children, ImgBanner, banner, banners, category, verticalAlign, city, city_id,} = this.props;

        const path = category ? APP.images.categories.path : APP.images.places.path;
        let image = false;
        let style = {};

        if (ImgBanner && !banner) {
            image = ImgBanner;
        } else if (banner) {
            image = path + banner;
        }

        if(image){
            style = {height: 500};
        }

        if (image) {
            style = {...style, backgroundImage: `url(${image})`};
        }

        return (
            <Container fluid className="main-header" style={style}>
                <Menu/>

                {banners && <Banners banners={banners} style={style} city={city} city_id={city_id} />}

                {
                    !image
                        ? children
                        :
                        <Banner verticalAlign={verticalAlign}>
                            {children}
                        </Banner>
                }
            </Container>
        );
    }
}
